// accordion js
$(document).ready(() => {
  $('.club-accordion-wrap').on('click', '.accordion-toggle', function () {
    const wrap = $(this).closest('.club-accordion-wrap');
    const content = wrap.find('.accordion-content');

    content.slideToggle(300);
    wrap.toggleClass('active');
  });
});
